import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    lobbies: [],
 };

export const lobbiesSlice = createSlice({
    name: 'lobbies',
    initialState,
    reducers: {
        setLobbies(state, action) {
            state.lobbies = action.payload;
        },
    }
});

export default lobbiesSlice;